export const NAIRA = '₦';
export const PERCENT = '%';
export const MONTHS = [
    {name:"January",value:1},
    {name:"February",value:2},
    {name:"March",value:3},
    {name:"April",value:4},
    {name:"May",value:5},
    {name:"June",value:6},
    {name:"July",value:7},
    {name:"August",value:8},
    {name:"September",value:9},
    {name:"October",value:10},
    {name:"November",value:11},
    {name:"December",value:12}
]
export const AUTH_TOKEN_NAME = 'bursary-app-access-token';

export const USER_STORE_KEY = 'bursary-app-user-store-key';

export const SERVER_URL = process.env.REACT_APP_SERVER_URL;